import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Actions from '../../actions';
import APP_ACTIONS from '../../constants/app-actions';
// eslint-disable-next-line import/no-cycle
import PaymentForm from '../../components/checkout-steps/payment-form';
import CheckoutStepCalculator from '../../services/checkout-step-calculator';
import APP_ROUTES from '../../constants/app-routes';

const mapStateToProps = (state, ownProps) => ({
    order: state.order,
    placedOrder: state.placedOrder,
    locale: state.locale,
    displayPreview: false,
    hasBackButton: false,
    isReadOnly: state.order.isCreditCardValidated,
    displayLoader: state.displayLoader,
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentCheckoutStep: () => {
        dispatch({
            type: APP_ACTIONS.SET_CURRENT_CHECKOUT_STEP,
            payload: 'payment',
        });
    },

    handlePaymentFormSubmit: (formData, order, locale) => dispatch(Actions.goToNextStep(order, locale, formData, false)),

    handleCheckoutStepNotEditable: (order, placedOrder) => {
        /* Redirect to last step if order is already placed */
        if (placedOrder.id) {
            dispatch(push(APP_ROUTES.checkout[`${placedOrder.checkout_steps.slice(-1)}PageRoute`]));
        } else if (order.id) {
            const previousStep = CheckoutStepCalculator.previous(order.checkout_steps, 'payment');

            dispatch(push(APP_ROUTES.checkout[`${previousStep}PageRoute`]));
        } else {
            dispatch(push(APP_ROUTES.cartPageRoute));
        }
    },

    handleCreditCardChange: () => {
        dispatch({
            type: APP_ACTIONS.VALIDATE_CREDIT_CARD,
            payload: false,
        });
    },

    handleSaveCreditCardSuccess: () => {
        dispatch({
            type: APP_ACTIONS.VALIDATE_CREDIT_CARD,
            payload: true,
        });
    },

    redirectToCart: () => dispatch(push(APP_ROUTES.cartPageRoute)),

    showFormErrors: (errorNode) => {
        // dispatch(Actions.showFlash(errorNode, 'danger'));
    },
});

const PaymentFormConnector = connect(mapStateToProps, mapDispatchToProps)(PaymentForm);

export default PaymentFormConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/checkout-steps/payment-form-connector.js
 **/